<svg width="62" height="66" viewBox="0 0 62 66" fill="none" xmlns="http://www.w3.org/2000/svg" style={$$props.style}>
  <g class="house">
    <path d="M1.67442 25.7618V63.8726H59.721V25.7618L30.6977 2L1.67442 25.7618Z"/>
    <path d="M40.3721 38.0742H21.0233V63.8727H40.3721V38.0742Z"/>
  </g>
</svg>
<style>
  .house {
    stroke: currentColor;
    stroke-width: 3;
    stroke-linecap: square;
  }
</style>